// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3PEBM","content":"GlobalSearch_content__1203d"};